import { useTranslation } from "react-i18next";
import { isArrayWithItems } from "../../../helpers";
import { TImage } from "../../../types";
import { TIndexableBlock } from "../../../types/general-block-types";
import Heading from "../../elements/heading/heading";
import InPageLinks, { TInPageLink } from "../../elements/in-page-links/in-page-links";
import styles from "./article-block-v2.module.less";
import { TopImage } from "./components/top-image";
import { useAnimateFadeIn } from "../../../animation/animation";
import { m as motion } from "motion/react";

export type TArticleBlockV2Props = {
  date?: string;
  category?: string;
  mobileImage?: TImage;
  desktopImage?: TImage;
  heading?: string;
  preamble?: string;
  inPageLinks?: Array<TInPageLink>;
  body?: React.ReactNode;
  sideComponent?: React.ReactNode;
} & TIndexableBlock;

const ArticleBlockV2 = ({
  date,
  category,
  mobileImage,
  desktopImage,
  heading,
  preamble,
  inPageLinks,
  body,
  sideComponent,
  index,
}: TArticleBlockV2Props) => {
  const { t } = useTranslation();

  const fadeInAnimation = useAnimateFadeIn({ whileInView: false, easing: "easeInOut" });

  return (
    <section className={styles.section}>
      <motion.article {...fadeInAnimation} className={["padded-sides max-width", styles.article].join(" ")}>
        {(date || category) && (
          <div className={styles.metaWrapper}>
            {date && <span className={"eyebrow"}>{date}</span>}
            {category && <span className={"eyebrow"}>{category}</span>}
          </div>
        )}

        {heading && (
          <Heading
            semanticType={index === 0 ? "h1" : "h2"}
            visualType={"h1"}
            className={[styles.heading, "heading-max-width"].join(" ")}
            index={index}
          >
            {heading}
          </Heading>
        )}
        <div className={styles.contentWrapper}>
          <div className={`${styles.content}`}>
            {(mobileImage || desktopImage) && <TopImage imageMobile={mobileImage} imageDesktop={desktopImage} />}
            {preamble && <p className={`${styles.preamble} preamble text-max-width`}>{preamble}</p>}
            {isArrayWithItems(inPageLinks) && <InPageLinks title={t("TABLE_OF_CONTENTS_TITLE")} links={inPageLinks} />}
            {body && <div className={`${styles.body} article text-max-width`}>{body}</div>}
          </div>
          <aside className={[styles.sideComponents, "text-max-width"].join(" ")}>
            {sideComponent && sideComponent}
          </aside>
        </div>
      </motion.article>
    </section>
  );
};

export default ArticleBlockV2;
